export enum EnumTheme {
    blue = "blue",
    green = "green",
    yellow = "yellow",
    red = "red",
    papular = "papular",
}

export enum EnumLang {
    fa = "fa",
    en = "en",
}
    
export enum EnumPosition {
    auto = "auto",
    rightTop = "rightTop",
    rightBottom = "rightBottom",
    leftTop = "leftTop",
    leftBottom = "leftBottom",
}
